import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';
import { testListPageStyles } from '../Tests.styles';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useMyTestsStyles = makeStyles(() => ({
  ...testListPageStyles,
  sections: {
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
    marginTop: spacing.md,
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(232px, 1fr))',
    gap: 20,
    alignItems: 'stretch',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      display: 'flex',
      alignItems: 'stretch',
      overflowX: 'auto',
      gap: 20,
      marginRight: -spacing.sm,
      paddingRight: spacing.sm,
      scrollSnapType: 'x proximity',
      WebkitOverflowScrolling: 'touch',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },
  cardGridItem: {
    display: 'flex',
    minHeight: '100%',
    '& > *': {
      flex: 1,
      width: '100%',
      minHeight: '100%',
    },
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      flex: '0 0 232px',
      width: 232,
      scrollSnapAlign: 'start',
    },
  },
  categoryPanel: {
    border: `1px solid rgba(44, 26, 16, 0.12)`,
    borderRadius: radius.md,
    backgroundColor: '#fdfaf5',
    overflow: 'hidden',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      marginRight: -spacing.sm,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderRight: 'none',
    },
  },
  categoryHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.sm,
    minHeight: 75,
    padding: `0px ${spacing.md}px`,
    borderBottom: `1px solid rgba(44, 26, 16, 0.12)`,
    backgroundColor: 'rgba(237, 232, 220, 0.4)',
  },
  categoryTitleWrap: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    flex: 1,
    minWidth: 0,
  },
  categoryHeaderMain: {
    display: 'flex',
    flex: 1,
    minWidth: 0,
    alignItems: 'center',
    gap: spacing.sm,
  },
  categoryHeaderContent: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
  },
  categoryIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    borderRadius: radius.sm,
    backgroundColor: colors.brownLight,
    color: colors.white,
    overflow: 'hidden',
    flexShrink: 0,
  },
  categoryIconImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  categoryEyebrow: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.sm,
    color: colors.brownLight,
    letterSpacing: 2,
    textTransform: 'uppercase',
    lineHeight: 1.1,
  },
  categoryTitle: {
    margin: 0,
    minWidth: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.md,
    color: '#2c1a10',
    lineHeight: '20px',
    paddingTop: 3,
  },
  countPill: {
    flex: '0 0 auto',
    padding: `${spacing.xs}px 12px`,
    borderRadius: radius.sm,
    backgroundColor: 'rgba(122, 101, 85, 0.13)',
    color: colors.brownLight,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.sm,
  },
  categoryBody: {
    padding: spacing.sm,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      padding: `${spacing.sm}px 0 ${spacing.sm}px ${spacing.sm}px`,
      '& $cardGrid': {
        marginRight: 0,
      },
    },
  },
  cardButtonIcon: {
    width: 16,
    height: 16,
  },
}));
